module.exports = __webpack_public_path__ + "img/pizzaset-759.4402b9da.png";